import {extendTheme} from '@chakra-ui/react';

const theme = extendTheme({
  colors: {
    blue: {
      100: '#E2F5FE',
      400: '#39A1D5',
      500: '#0083C9'
    },
    gray: {
      100: '#F0F0F0',
      200: '#D6D6D6',
      500: '#8D8D8D',
      600: '#959595'
    }
  },
  sizes: {
    contentSm: '89.33333333333333vw',
    content: '70vw'
  },
  lineHeights: {
    base: 2
  },
  fonts: {
    body: "'Noto Sans JP', sans-serif",
    heading: "'Noto Sans JP', sans-serif"
  },
  components: {
    Heading: {
      baseStyle: {
        textAlign: 'center'
      }
    }
  }
});

export default theme;
export const CHART_COLORS = [
  {
    text: '#0083C9',
    bg: '#DDF3FE'
  },
  {
    text: '#E09B00',
    bg: '#FEFFE3'
  },
  {
    text: '#DB5A7C',
    bg: '#FCEDF1'
  },
  {
    text: '#55B25D',
    bg: '#E4FAE6'
  },
  {
    text: '#0FABC7',
    bg: '#DAF8FD'
  },
  {
    text: '#E25E37',
    bg: '#FFECE6'
  },
  {
    text: '#AF5BB2',
    bg: '#F2E6F2'
  },
  {
    text: '#26A885',
    bg: '#E2F8F2'
  },
  {
    text: '#5467D3',
    bg: '#E2E5F5'
  },
  {
    text: '#C78E4A',
    bg: '#F2EBE2'
  }
];
